// ===== review_slider =====
document.addEventListener('DOMContentLoaded', () => {
  document.querySelector('.button--open--loox').addEventListener('click', e => {
    e.preventDefault()
    if (document.querySelector('.loox-rating')) {
      document.querySelector('.loox-rating').click()
    }
  })
  new Swiper('.review_slider', {
    speed: 1000,
    spaceBetween: 16,
    pagination: {
      el: '.review_slider .swiper-pagination',
      clickable: true,
    },
    navigation: {
      nextEl: '.review_slider_wrapper .swiper-button-next',
      prevEl: '.review_slider_wrapper .swiper-button-prev',
    },
    breakpoints: {
      0: {
        slidesPerView: 1,
        centeredSlides: true,
        spaceBetween: 10,
      },
      768: {
        slidesPerView: 3,
        centeredSlides: true,
      },
      992: {
        slidesPerView: 5,
        centeredSlides: false,
      },
    },
  })
})
